// extracted by css-extract-rspack-plugin
export default {"HeadlineImage":"HeadlineImage-zV2SSa","headlineImage":"HeadlineImage-zV2SSa","Headline":"Headline-dxtM20","headline":"Headline-dxtM20"};